import HundredBricksAPIError from '../../../HundredBricksAPIError';
class CrowdfundingPropertiesError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('CrowdfundingPropertiesError', ...args);
    }
}
export default CrowdfundingPropertiesError;
